import React from 'react';
import { Checkbox } from 'antd';
import FormItem from './FormItem';

export default function FormCheckbox({ editable, name, title, value, error, onChange, layout, label, required, ...props }) {
  return (
    <FormItem
      label={label}
      required={required}
      error={error}
      layout={layout}
    >
      <Checkbox
        name={name}
        checked={value}
        onChange={onChange}
        {...props}
      >
        {title}
      </Checkbox>
    </FormItem>
  );
}



// WEBPACK FOOTER //
// ./src/components/BaseForm/components/CheckBox.js